import {templateConstants} from '../constants/template.constants'
import {createAPIClient} from '../services/api'
import {head, get} from 'lodash'

export function getTemplatesAction (successCallback) {
  return dispatch => {
    dispatch(request())  // could be removed
    const api = createAPIClient()
    api.get(`/api/templates`)
      .then(result => {
        const {data: body} = result
        const {response} = body
        const templates = response.items
        dispatch(success({templates}))
        successCallback(templates)
      })
      .catch(error => {
        dispatch(failure(error))
      })
  }

  function request () {
    return {type: templateConstants.GETALL_REQUEST}
  }

  function success (payload) {
    return {type: templateConstants.GETALL_SUCCESS, payload}
  }

  function failure (error) {
    return {type: templateConstants.GETALL_FAILURE, error}
  }
}



// WEBPACK FOOTER //
// ./src/actions/template.action.js